// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"1606f990","155":"2fdfd929","369":"dc60ac64","432":"d1acba59","438":"ebde2040","453":"c6424d65","491":"52c6abfe","492":"3354719d","561":"652e310b","962":"10c6aba7","980":"f743e99c"}[chunkId] + ".chunk.js";
};